import { t } from 'i18next';
// components
import { WavePulse } from '@commons/components';
// styles
import styles from './Title.module.css';

const Title = () => {
    return (
        <div className={styles['title']}>
            <span>{t('newWidgetHome.title')}</span>
            <WavePulse />
        </div>
    );
};

export default Title;
